/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentPropsResponse } from './AppointmentPropsResponse';
import {
    AppointmentPropsResponseFromJSON,
    AppointmentPropsResponseFromJSONTyped,
    AppointmentPropsResponseToJSON,
    AppointmentPropsResponseToJSONTyped,
} from './AppointmentPropsResponse';

/**
 * Response for an appointment.
 * @export
 * @interface AppointmentResponse
 */
export interface AppointmentResponse {
    /**
     * Tell if the patient has an appointment or not
     * @type {boolean}
     * @memberof AppointmentResponse
     */
    isPatientWithoutAppointment?: boolean;
    /**
     * Start date
     * @type {string}
     * @memberof AppointmentResponse
     */
    start?: string;
    /**
     * End date
     * @type {string}
     * @memberof AppointmentResponse
     */
    end?: string;
    /**
     * Name of appointment type
     * @type {string}
     * @memberof AppointmentResponse
     */
    title?: string;
    /**
     * 
     * @type {AppointmentPropsResponse}
     * @memberof AppointmentResponse
     */
    extendedProps?: AppointmentPropsResponse;
    /**
     * specific css class
     * @type {Array<string>}
     * @memberof AppointmentResponse
     */
    classNames?: Array<string>;
    /**
     * data to param displaying
     * @type {string}
     * @memberof AppointmentResponse
     */
    display?: string;
}

/**
 * Check if a given object implements the AppointmentResponse interface.
 */
export function instanceOfAppointmentResponse(value: object): value is AppointmentResponse {
    return true;
}

export function AppointmentResponseFromJSON(json: any): AppointmentResponse {
    return AppointmentResponseFromJSONTyped(json, false);
}

export function AppointmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isPatientWithoutAppointment': json['isPatientWithoutAppointment'] == null ? undefined : json['isPatientWithoutAppointment'],
        'start': json['start'] == null ? undefined : json['start'],
        'end': json['end'] == null ? undefined : json['end'],
        'title': json['title'] == null ? undefined : json['title'],
        'extendedProps': json['extendedProps'] == null ? undefined : AppointmentPropsResponseFromJSON(json['extendedProps']),
        'classNames': json['classNames'] == null ? undefined : json['classNames'],
        'display': json['display'] == null ? undefined : json['display'],
    };
}

export function AppointmentResponseToJSON(json: any): AppointmentResponse {
    return AppointmentResponseToJSONTyped(json, false);
}

export function AppointmentResponseToJSONTyped(value?: AppointmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isPatientWithoutAppointment': value['isPatientWithoutAppointment'],
        'start': value['start'],
        'end': value['end'],
        'title': value['title'],
        'extendedProps': AppointmentPropsResponseToJSON(value['extendedProps']),
        'classNames': value['classNames'],
        'display': value['display'],
    };
}

